import { React } from 'react';
import loadingImage from '../../Images/loading/loading.svg';
import loadingGif from '../../Images/Common/loading.gif';
import loadingGifMobile from '../../Images/Common/loading.gif';
import './style.scss';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Loading = ({
  waitingTitle,
  waitingSubTitle,
  containerStyle,
  wrapperClass,
  showText = true,
}) => {
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />;
  return (
    <div
      className={`loading_main_container ${wrapperClass ? wrapperClass : ''}`}
      style={{ ...containerStyle }}
    >
      <div className="content">
        <div className="loading_image_container">
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: '40px', color: '#d85252' }}
                spin
              />
            }
            className="desktop"
          />
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: '20px', color: '#d85252' }}
                spin
              />
            }
            className="mob"
          />
        </div>
        {showText && <div className="waiting_title">{waitingTitle}</div>}
        {showText && <div className="waiting_sub_title">{waitingSubTitle}</div>}
      </div>
    </div>
  );
};
export default Loading;
